export const ADMIN = 'admin'
export const BPU_DISPLAY = 'Bullying Unit'
export const BPU_OFF = ' (OFF)'
